import { useState } from 'react';
import { AuthenticatorType } from '@mews-commander/data-access';
import { LocalizedParagraph } from '@mews-commander/ui';
import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { TwoFactorAuthenticationSelectionCardGroup } from '../../components/TwoFactorAuthenticationSelectionCardGroup';

interface Configure2FAPanelSelectMethodProps {
    onClose: () => void;
    onSelectRoute: (route: AuthenticatorType) => void;
}

export function Configure2FAPanelSelectMethod({ onSelectRoute, onClose }: Configure2FAPanelSelectMethodProps) {
    const [selected2FAMode, setSelected2FAMode] = useState(AuthenticatorType.Google);

    return (
        <FloatingPanel
            modal
            size="small"
            active
            title={<LocalizedText textKey={TextKey.EnableTwoFactorAuthentication} />}
            onClose={onClose}
            footer={{
                primary: (
                    <Button
                        size="medium"
                        variant="primary"
                        onClick={() => onSelectRoute(selected2FAMode)}
                        type="submit"
                    >
                        <LocalizedText textKey={TextKey.Next} />
                    </Button>
                ),
            }}
        >
            <Stack vertical spacing="300">
                <LocalizedParagraph textKey={TextKey.EnableTwoFactorAuthenticationDescription} />
                <TwoFactorAuthenticationSelectionCardGroup inputValue={selected2FAMode} onChange={setSelected2FAMode} />
            </Stack>
        </FloatingPanel>
    );
}
